import { SelectInput } from "react-admin";
import React from "react";
import { useField } from "react-final-form";

const NotificationTargetInput = () => {
  const routeInput = useField("routeId");
  const schoolInput = useField("schoolId");
  const busScheduleInput = useField("busScheduleId");
  const parentsInput = useField("parentIds");
  const driversInput = useField("driverIds");

  const reset = () => {
    schoolInput.input.onChange("");
    busScheduleInput.input.onChange("");
    routeInput.input.onChange("");
    parentsInput.input.onChange([]);
    driversInput.input.onChange([]);
  };

  return (
    <SelectInput
      source="notificationTargetType"
      choices={[
        { id: "bus_schedule", name: "Wave" },
        { id: "route", name: "Route" },
      ]}
      initialValue="bus_schedule"
      onChange={reset}
    />
  );
};

export default NotificationTargetInput;
